var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProsharing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.99,
    height: 89.5,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.99 89.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #9bc83a;\n      }\n\n      .cls-3 {\n        stroke: #40535e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        fill: #f7981d;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        fill: #0b845c;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 66.78,
    y1: 40.55,
    x2: 88.14,
    y2: 61.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e70d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc3265"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 77.46,
    cy: 51.33,
    r: 15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 16.62,
    y1: 17.65,
    x2: 37.98,
    y2: 39.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a74aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#085786"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 27.4,
    cy: 28.44,
    r: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 58.98,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 26.21,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.28,
    y: 9.5,
    width: 97,
    height: 62,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 77.46,
    cy: 51.23,
    r: 15.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M97.79,62.46c0,.95-.77,1.72-1.72,1.72-.95,0-1.72-.77-1.72-1.72,0-.95,.77-1.72,1.72-1.72,.95,0,1.72,.77,1.72,1.72h0Zm-.86,0c0,.48-.39,.86-.86,.86s-.86-.39-.86-.86,.39-.86,.86-.86,.86,.39,.86,.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M96.07,58.59c2.35,0,4.41,1.59,5,3.87-.72,2.76-3.54,4.42-6.3,3.7-1.81-.47-3.23-1.89-3.7-3.7,.59-2.28,2.65-3.87,5-3.87Zm0,6.89c-1.88,0-3.54-1.22-4.11-3.01,.71-2.27,3.13-3.53,5.4-2.81,1.34,.42,2.39,1.47,2.81,2.81-.56,1.79-2.23,3.01-4.11,3.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.96,
    cy: 65.83,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.96,
    cy: 48.83,
    r: 4.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 27.3,
    cy: 28.33,
    r: 15.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.04,33.59c-.19-.19-.49-.19-.67,0l-.42,.42c-.55-.26-1.2-.15-1.63,.28l-5.06,5.05,2.7,2.7,5.06-5.06c.43-.43,.54-1.08,.28-1.63l.42-.42c.19-.19,.19-.49,0-.67l-.68-.68Zm-2.03,4.06l-3.04,3.04-1.35-1.35,3.05-3.04,1.35,1.35Zm.87-.87l.47-.47c.19-.19,.19-.49,0-.67l-.67-.67c-.19-.19-.49-.19-.67,0l-.47,.47,1.35,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.86,43.44l1.01-3.71,2.7,2.7-3.71,1.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 27.9,
    cy: 42.94,
    r: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 27.9,
    cy: 25.94,
    r: 4.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 103.23,
    cy: 78.74,
    r: 10.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.78,77.29h-4.1v-4.1c0-.55-.45-1-1-1h-.9c-.55,0-1,.45-1,1v4.1h-4.1c-.55,0-1,.45-1,1v.9c0,.55,.45,1,1,1h4.1v4.1c0,.55,.45,1,1,1h.9c.55,0,1-.45,1-1v-4.1h4.1c.55,0,1-.45,1-1v-.9c0-.55-.45-1-1-1Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProsharing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pro.sharing.b02a97b9ec1466c958df111d771ba57b.svg";